import { createContext, useContext, useMemo } from 'react'

import { BlockConfigAlgolia } from '@Globals/Algolia/Types'
import { BlockConfigAnchorInjections } from '@Globals/Injections/Types'

export const BlockContext = createContext({
  blockID: 'unknown',
  blockType: 'unknown',
  id: 'unknown',
  shouldFillContainer: false,
})

export interface BlockConfig {
  algolia?: BlockConfigAlgolia
  anchorInjections?: BlockConfigAnchorInjections
}

export const BlockConfigContext = createContext<Record<string, BlockConfig>>({})

export const useBlockConfig = () => {
  const { blockID, blockType } = useContext(BlockContext)
  const blockConfig = useContext(BlockConfigContext)
  return useMemo(() => blockConfig[`${blockType}:${blockID}`] ?? {}, [blockConfig, blockID, blockType])
}
